module.exports = __webpack_public_path__ + "static/media/first-patient-down.ce32281c.png";